module.exports = __webpack_public_path__ + "static/media/FriendDirectory.50d19149.png";